import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducer(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/providers/producers/${agro_exporter_id}/fetch_producer/${producer_id}`
    );
  },
  createProducer(agro_exporter_id, producer) {
    return RequesterV1.post(
      `agro_exporter/providers/producers/${agro_exporter_id}/create_producer`,
      { producer }
    );
  },
  updateProducer(agro_exporter_id, producer_id, producer) {
    return RequesterV1.post(
      `agro_exporter/providers/producers/${agro_exporter_id}/update_producer/${producer_id}`,
      { producer }
    );
  },
  destroyProducer(agro_exporter_id, producer_id) {
    return RequesterV1.delete(
      `agro_exporter/providers/producers/${agro_exporter_id}/destroy_producer/${producer_id}`
    );
  },
};
